import { ReactionKind } from "client/Api/Hub/common";
import { environmentHttpClient } from "client/Api/httpClient";

export type MakeBirthdayWishModel = {
	toUserId: number;
	birthdayWish: string;
};

export function makeBirthdayWish(
	model: MakeBirthdayWishModel
): Promise<void> {
	return environmentHttpClient.post<void>(
		"/BirthdayWishes/",
		model
	);
};

export function registerBirthdayWishReaction(
	birthdayWishId: number,
	kind: ReactionKind,
	signal?: AbortSignal
): Promise<ReactionKind> {
	return environmentHttpClient.post<ReactionKind>(
		`/BirthdayWishes/${birthdayWishId}/Reactions`,
		kind,
		{ signal }
	);
}

export function updateBirthdayWishReaction(
	birthdayWishId: number,
	kind: ReactionKind,
	signal?: AbortSignal
): Promise<ReactionKind> {
	return environmentHttpClient.put<ReactionKind>(
		`/BirthdayWishes/${birthdayWishId}/Reactions`,
		kind,
		{ signal }
	);
}

export function unregisterBirthdayWishReaction(
	birthdayWishId: number,
	signal?: AbortSignal
): Promise<ReactionKind> {
	return environmentHttpClient.delete<ReactionKind>(
		`/BirthdayWishes/${birthdayWishId}/Reactions`,
		undefined,
		{ signal }
	);
}
